"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[362],{

/***/ 50362:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88121);



/* harmony default export */ __webpack_exports__["default"] = ((0,client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
    d: "M17 5H3C2.4 5 2 5.4 2 6V17C2 17.6 2.4 18 3 18H4.2C4.6 19.2 5.7 20 7 20C8.3 20 9.4 19.2 9.8 18H14.2C14.6 19.2 15.7 20 17 20C18.3 20 19.4 19.2 19.8 18H21C21.6 18 22 17.6 22 17V10C22 7.2 19.8 5 17 5ZM20 10H16V7H17C18.7 7 20 8.3 20 10ZM10 10V7H14V10H10ZM8 7V10H4V7H8ZM7 18C6.4 18 6 17.6 6 17C6 16.4 6.4 16 7 16C7.6 16 8 16.4 8 17C8 17.6 7.6 18 7 18ZM17 18C16.4 18 16 17.6 16 17C16 16.4 16.4 16 17 16C17.6 16 18 16.4 18 17C18 17.6 17.6 18 17 18ZM19.8 16C19.4 14.8 18.3 14 17 14C15.7 14 14.6 14.8 14.2 16H9.8C9.4 14.8 8.3 14 7 14C5.7 14 4.6 14.8 4.2 16H4V12H20V16H19.8Z"
}), "Transportation"));


/***/ })

}]);